import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=2be2478d&scoped=true"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentComponent.vue?vue&type=style&index=0&id=2be2478d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2478d",
  null
  
)

export default component.exports